{
  "battles.status.stunned": "Stunned",
  "battles.status.stunnedDesc": "Cannot act this turn. Loses automatically.",
  "battles.status.wounded": "Wounded ({turns})",
  "battles.status.woundedShort": "Wounded",
  "battles.status.woundedDesc": "Healing is halved ({percent}%) for the next {turns, plural, one {# turn} other {# turns}}. Attacking no longer breaks it.",
  "battles.status.bleed": "Bleed {damage}/turn ×{turns}",
  "battles.status.bleedShort": "Bleed {damage}",
  "battles.status.bleedDesc": "Takes {damage} damage at the end of each of the next {turns, plural, one {# turn} other {# turns}} — after that turn's healing and shields.",
  "battles.status.forceMagic": "Force Magic",
  "battles.status.forceMagicDesc": "Must use magic next turn (can resist).",
  "battles.status.forceRecover": "Force Recover",
  "battles.status.forceRecoverDesc": "Must use recover next turn (can resist).",
  "battles.status.forceAttack": "Force Attack",
  "battles.status.forceAttackDesc": "Must Attack next turn (can resist).",
  "battles.status.noMagic": "No Magic",
  "battles.status.noMagicDesc": "Cannot use magic next turn. Redirected to another action.",
  "battles.status.noRecover": "No Recover",
  "battles.status.noRecoverDesc": "Cannot use recover next turn. Redirected to another action.",
  "battles.status.fatigued": "Fatigued",
  "battles.status.fatiguedDesc": "Attack deals 50% damage due to fatigue. Use Magic or Recover to reset.",
  "battles.status.charged": "Charged",
  "battles.status.chargedDesc": "Next magic deals +{percent}% damage!",
  "battles.status.shield": "Shield +{amount}",
  "battles.status.shieldDesc": "Absorbs up to {amount} incoming damage. Never decays; a new shield replaces this value.",
  "battles.status.drain": "Drain +{amount}",
  "battles.status.drainDesc": "Heals {amount} at start of next turn.",
  "battles.status.stunImmune": "Stun Immune",
  "battles.status.stunImmuneDesc": "Cannot be stunned this turn (recently stunned).",
  "battles.status.precise": "Precise",
  "battles.status.preciseDesc": "Attack cannot be dodged. Dodge fails against this species!",
  "battles.status.turnsLeft": "{turns, plural, one {# turn left} other {# turns left}}",
  "battles.fighter.levelTitle": "Combat Level",
  "battles.fighter.levelAria": "Level {level}",
  "battles.fighter.levelBadge": "Lv{level}",
  "battles.fighter.hpAria": "{hp} of {maxHp} HP",
  "battles.fighter.hpWithEvolutionAria": "{hp} of {maxHp} HP, {evolutionHp} of it added by evolving",
  "battles.fighter.faintedAria": "{name} fainted",
  "battles.fighter.departedAria": "{name} left the field",
  "battles.fighter.swapInDamage": "-{damage} HP",
  "battles.fighter.swapInHit": "Hit on switch-in!",
  "battles.timer.seconds": "{seconds}s",
  "battles.turn.outcomeWin": "Win",
  "battles.turn.outcomeLose": "Lose",
  "battles.turn.outcomeTie": "Tie",
  "battles.turn.outcomeCritAria": "{outcome} — critical hit, the move landed {multiplier}",
  "battles.log.turn": "T{turn}",
  "battles.log.switchedIn": "Switched in",
  "battles.log.usedPill": "Used a pill",
  "battles.log.damageOnSwitchIn": "Damage taken on switch-in",
  "battles.log.damageWhileDrinking": "Damage taken while drinking",
  "battles.log.versus": "vs",
  "battles.log.turnCount": "{count, plural, =0 {No turns} one {# turn} other {# turns}}",
  "battles.log.currentTurn": "{count, plural, =0 {Ready} other {Turn #}}",
  "battles.reward.xpTotal": "{xp} XP",
  "battles.reward.xpEarned": "{xp} XP earned",
  "battles.reward.trophies": "Trophies",
  "battles.reward.experience": "Experience",
  "battles.reward.tallying": "Tallying your rewards…",
  "battles.reward.tierReached": "{tier} Tier Reached!",
  "battles.result.deadLevel": "Dead level",
  "battles.result.margin": "{name} by {margin} HP",
  "battles.result.battleAgain": "Battle Again",
  "battles.result.exit": "Exit",
  "battles.result.close": "Close result",
  "battles.result.victory": "VICTORY!",
  "battles.result.defeat": "DEFEAT",
  "battles.result.draw": "DRAW",
  "battles.result.shikaWinAlt": "Shika celebrates the win",
  "battles.result.shikaLossAlt": "Shika reacts to the loss",
  "battles.result.tiebreak": "⏱ Tiebreak — Turn {turn}",
  "battles.result.drawSubtitle": "Neither of you would go down",
  "battles.result.winsOnHp": "{name} wins on HP",
  "battles.result.wins": "{name} wins!",
  "battles.result.showResult": "Show Result",
  "battles.result.openRewards": "Open Rewards",
  "battles.board.yourMoves": "Your moves",
  "battles.board.rotateTitle": "Turn your phone upright",
  "battles.board.rotateNote": "A round needs the height: both Suikamon, your hand, and the four moves.",
  "battles.skill.cardsFullCommit": "🃏 {held} cards — takes the round unless they commit {needed} too",
  "battles.skill.cardsFullRecover": "❤️ …and FULL HP, no damage, every debuff gone",
  "battles.skill.cardsWasted": "⚠️ {count, plural, one {# more card} other {# more cards}} spent for nothing",
  "battles.skill.bonusExecute": "⚔️ Execute Active! (+{value})",
  "battles.skill.bonusExploitBleed": "🔥 Exploits bleed! (+{value})",
  "battles.skill.bonusExploitWound": "🩸 Exploits wound! (+{value})",
  "battles.skill.bonusExploitStun": "🌀 Exploits stun! (+{value})",
  "battles.skill.bonusPunishAttack": "💢 Punishes their attack! (+{value})",
  "battles.skill.bonusPlain": "+{value}",
  "battles.skill.chargedShort": "⚡ Charged +{bonus}",
  "battles.skill.chargedLong": "⚡ Charged — this Magic lands +{bonus}",
  "battles.skill.evolutionMax": "🧬 Max Evo — +{percent}% damage",
  "battles.skill.evolutionMaxLong": "🧬 Max Evo — +{percent}% damage (+{bonus})",
  "battles.skill.evolutionRank": "🧬 Evolution {rank} — +{percent}% damage",
  "battles.skill.evolutionRankLong": "🧬 Evolution {rank} — +{percent}% damage (+{bonus})",
  "battles.skill.pressureShort": "⏱️ Round {round} — {percent}% damage",
  "battles.skill.pressureLong": "⏱️ Round {round} — the fight tightens, every blow lands at {percent}%",
  "battles.skill.cardMissedShort": "🚫 {card} has no target — cards wasted",
  "battles.skill.cardMissedLong": "🚫 {card} finds nothing to read — it adds no damage, and the cards are spent anyway",
  "battles.skill.boostedShort": "⚡ Boosted — +1 copy",
  "battles.skill.boostedLong": "⚡ Boosted this round — your stack plays a copy bigger",
  "battles.skill.elementAdvantage": "✨ Element Advantage!",
  "battles.skill.preciseShort": "🎯 Precise — {percent}% hits through dodge",
  "battles.skill.preciseLong": "🎯 Precise Attack - {percent}% chance to hit through dodge",
  "battles.skill.fatiguedShort": "😓 Fatigued — {percent}% damage",
  "battles.skill.fatiguedLong": "😓 Fatigued — Attack deals {percent}% damage",
  "battles.skill.woundedShort": "🩸 Wounded — {percent}% healing",
  "battles.skill.woundedLong": "🩸 Wounded — healing cut to {percent}%",
  "battles.skill.locked": "🔒 Locked from repeated use",
  "battles.skill.noRecoversLeft": "❌ No recovers left",
  "battles.skill.noThirdDodgeShort": "🚫 No third dodge in a row",
  "battles.skill.noThirdDodgeLong": "🚫 Cannot dodge three times in a row",
  "battles.skill.levelLocked": "🔒 Unlocks at a higher level",
  "battles.skill.noMagic": "🚫 No magic ability",
  "battles.skill.noCardsShort": "🃏 No cards — pitch for one",
  "battles.skill.noCardsLong": "🃏 No cards of this move — pitch for one",
  "battles.skill.attackTitle": "Attack: {name}",
  "battles.skill.magicTitle": "Magic: {name}",
  "battles.skill.closePopup": "Close",
  "battles.hand.titleEvolved": "Evolved",
  "battles.hand.titleDealt": "Hand set",
  "battles.hand.titleMove": "Make your move",
  "battles.hand.titleCommitted": "Locked in",
  "battles.hand.titleShape": "Shape your hand",
  "battles.hand.pileAria": "{count, plural, one {# card left in the pile} other {# cards left in the pile}}",
  "battles.hand.opponentCount": "Opponent {count}",
  "battles.hand.listShaping": "Your hand — tap a card to pitch it",
  "battles.hand.listRound": "Your hand for this round",
  "battles.hand.cardAria": "{card}, {suit}.",
  "battles.hand.cardHeldOfSet": "{held} of {needed} held.",
  "battles.hand.cardSetComplete": "Evolution set complete — your Suikamon evolves when the hand locks.",
  "battles.hand.cardOutranked": "Scores nothing — a bigger stack of this suit carries the commit.",
  "battles.hand.cardMarked": "Marked to pitch. Tap to keep it.",
  "battles.hand.cardTapToPitch": "Tap to pitch it.",
  "battles.hand.cardJustDrawn": "Just drawn.",
  "battles.hand.cardNew": "New this round.",
  "battles.hand.skip": "Skip",
  "battles.hand.hint": "Tap cards to swap them",
  "battles.hand.confirmPitch": "✓ Pitch {count} · draw",
  "battles.hand.confirmKeep": "✓ Keep all {count}",
  "battles.hand.spaceKey": "Space",
  "battles.hand.moveCue": "Your move ↓",
  "battles.squad.rivalOfTheDay": "Rival of the Day",
  "battles.squad.rivalWonDetail": "Every squad member",
  "battles.squad.rivalTriedDetail": "For taking the challenge",
  "battles.squad.xpAmount": "+{xp} XP",
  "battles.squad.soulShardsBecameSuika": "You already have {species}, so they became Suika",
  "battles.squad.soulShardsToward": "Toward recovering its soul",
  "battles.squad.statusAria": "Squad status",
  "battles.squad.loading": "Loading squad battle…",
  "battles.squad.leaveTitle": "Leave Battle?",
  "battles.squad.leaveCampaign": "You'll forfeit this rival battle. No campaign progress is lost — retry anytime.",
  "battles.squad.leaveRanked": "Your squad will forfeit and lose Trainer ELO.",
  "battles.squad.keepFighting": "Keep Fighting",
  "battles.squad.leaveConfirm": "Leave Battle",
  "battles.squad.leaveAria": "Leave battle",
  "battles.squad.versus": "VS",
  "battles.squad.pillsAria": "Pills remaining",
  "battles.squad.yourPillAvailable": "Your pill: available",
  "battles.squad.yourPillUsed": "Your pill: used",
  "battles.squad.enemyPillAvailable": "Enemy pill: available",
  "battles.squad.enemyPillUsed": "Enemy pill: used",
  "battles.squad.changeSuikamon": "Change selected Suikamon",
  "battles.squad.help": "Battle help",
  "battles.squad.roundLabel": "Round",
  "battles.squad.retry": "Retry",
  "battles.squad.returnToMap": "Return to Map",
  "battles.squad.emptyLog": "Pick an action to start.",
  "battles.log.bleedTicks": "Bleed: {damages} HP",
  "battles.ranked.opponentFound": "Opponent found!",
  "battles.ranked.searching": "Searching for opponent…",
  "battles.ranked.milestoneToast": "{tier} reached: {reward}",
  "battles.ranked.noOpponents": "No opponents found. Try again later!",
  "battles.ranked.kicker": "Ranked Battle",
  "battles.ranked.signUpSubtitle": "Sign up to make your Suikamon permanent and climb the ranked ladder.",
  "battles.ranked.title": "Ranked",
  "battles.ranked.loadingPets": "Fetching your Suikamon…",
  "battles.ranked.eggAlt": "Your egg",
  "battles.ranked.hatchToClimb": "Hatch your egg and your Suikamon can climb the ladder.",
  "battles.ranked.needHatched": "You need a hatched Suikamon to enter ranked battles.",
  "battles.ranked.hatchCta": "Hatch your egg",
  "battles.ranked.freeCta": "Get your free Suikamon",
  "battles.ranked.bracket": "Bracket Lv.{level}",
  "battles.ranked.xpPerWin": "✨ +{xp} XP a win",
  "battles.ranked.needSuika": "Need {cost} Suika to battle.",
  "battles.ranked.preparing": "⏳ Preparing…",
  "battles.ranked.findMatch": "⚔️ Find Match",
  "battles.ranked.eggReadyEyebrow": "Ranked Reward Ready",
  "battles.ranked.eggReadyTitle": "{name} has an unclaimed egg",
  "battles.ranked.eggReadyText": "Claim it here before your next match, or jump to Play and do it there later.",
  "battles.ranked.claimEgg": "🥚 Claim Egg Here",
  "battles.ranked.openPlay": "Open Play Page",
  "battles.ranked.record": "{name}'s record",
  "battles.lab.defeated": "DEFEATED",
  "battles.lab.title": "Battle Lab",
  "battles.lab.wins": "{wins} / {needed} wins",
  "battles.lab.attackAria": "Attack",
  "battles.lab.hpAria": "HP",
  "battles.lab.fighterOut": "{name}, knocked out",
  "battles.lab.fightWith": "Fight with {name}",
  "battles.lab.chooseFighter": "Choose your fighter",
  "battles.lab.complete": "You beat the Lab! {needed} wild Suikamon down. Now raise one of your own.",
  "battles.lab.overWithWins": "You won {count, plural, one {# battle} other {# battles}}. Raise a Suikamon of your own, or start a fresh run.",
  "battles.lab.overNoWins": "Your fighters are all out. Raise a Suikamon of your own, or start a fresh run.",
  "battles.lab.pickStarter": "Pick your starter",
  "battles.lab.startOver": "Start over",
  "battles.lab.tryAgain": "Try again",
  "battles.lab.pickAnother": "Your fighter was knocked out. Pick another one.",
  "battles.lab.finding": "Finding a challenger…",
  "battles.lab.battleWith": "⚔️ Battle with {name}",
  "battles.lab.wildTitle": "Wild Suikamon",
  "battles.lab.wildLine": "Beat {needed} to finish the Lab. Your opponent is picked at random.",
  "battles.impact.start": "FIGHT! CLASH! RUMBLE! BRAWL! SCRAP! DUEL! MELEE! ATTACK! CHARGE! ENGAGE! BANZAI! SHOWTIME! SHOWDOWN! HAVOC! MAYHEM! VERSUS! BATTLE! UNLEASH! DESTROY! STRIKE! SMASH! BEGIN! SKIRMISH! SLUGFEST! THROWDOWN! FEROCITY! ONSLAUGHT! GO! RAMPAGE! KUMITE!",
  "battles.impact.win": "BANG! BOOM! POW! KAPOW! WHAM! SMASH! KABOOM! BAM! WHACK! KRUNCH! ZAP! BLAM! SOCK! BIFF! WALLOP! THWACK! SLAM! CRASH! KABLAM! ZONK! SPLAT!",
  "battles.impact.lose": "OOF! OUCH! THUD! CRUNCH! CLONK! ARGH! YEOW! OW! WHUMP! DONK! BONK! CRACK! THUNK! OOMPH! YIKES! OWIE! UGH! WHUD!",
  "battles.impact.tie": "CLASH! CLANG! CLINK! TING! DEADLOCK! STANDOFF! KLANG! CHINK! STALEMATE! LOCKED! TRADE! EVEN!",
  "battles.impact.dodge": "DODGE! SWOOSH! WHOOSH! WHIFF! MISS! PARRY!",
  "battles.impact.critical": "CRITICAL!",
  "battles.squadRanked.title": "Squad Ranked",
  "battles.squadRanked.signUpSubtitle": "Sign up to make your Suikamon permanent and compete for Trainer ELO.",
  "battles.squadRanked.readyCount": "{ready} of {size} ready",
  "battles.squadRanked.needMore": "A squad is {size} hatched, awake Suikamon. {missing} more to go: new ones hatch from the eggs your Suikamon find as they level up.",
  "battles.squadRanked.train": "⚔️ Train {name}",
  "battles.squadRanked.viewMine": "View my Suikamon",
  "battles.squadRanked.rank": "Rank #{rank}",
  "battles.squadRanked.record": "{wins}W / {losses}L · {rate}%",
  "battles.squadRanked.dailyLimit": "{count, plural, one {# battle a day} other {# battles a day}}",
  "battles.squadRanked.token": "{name}, level {level}",
  "battles.squadRanked.tokenPlaced": "{name}, level {level}, squad place {place}",
  "battles.squadRanked.tokensAria": "Your squad of {size}",
  "battles.squadRanked.pickMore": "{count, plural, one {Pick # more Suikamon. The first one leads.} other {Pick # more Suikamon. The first one leads.}}",
  "battles.squadRanked.ready": "Your squad is ready. Wins raise your Trainer ELO.",
  "battles.squadRanked.preparing": "Preparing…",
  "battles.squadRanked.findMatch": "⚔️ Find Squad Match",
  "battles.squadRanked.ladderTitle": "🏆 Trainer ladder",
  "battles.squadRanked.ladderLoading": "Loading the ladder…",
  "battles.squadRanked.ladderRecord": "{wins}W {losses}L",
  "battles.squadRanked.ladderEmpty": "No Squad Ranked battles played yet.",
  "battles.arena.checkingActive": "Checking for active battles…",
  "battles.arena.finding": "Finding opponent…",
  "battles.arena.matchmakingFailed": "Matchmaking failed",
  "battles.arena.yourSuikamon": "Your Suikamon",
  "battles.arena.tryAgain": "Try Again",
  "battles.arena.leaveWarning": "If you leave now, <b>{name}</b> will be defeated and won't be available for this session.",
  "battles.arena.keepFighting": "⚔️ Keep Fighting",
  "battles.arena.exitBattle": "Exit Battle",
  "battles.arena.helpAria": "Battle help and leave battle",
  "battles.training.title": "Training",
  "battles.training.loadFailed": "Couldn't load your Suikamon. Check your connection and try again.",
  "battles.training.tryAgain": "Try again",
  "battles.training.hatchToTrain": "Hatch your egg and your Suikamon can train.",
  "battles.training.allResting": "💤 Every Suikamon is resting",
  "battles.training.wakeOne": "Wake one up to battle.",
  "battles.training.wake": "Wake {name}",
  "battles.training.finding": "🎰 Finding a challenger…",
  "battles.training.battle": "⚔️ Battle",
  "battles.training.wildLine": "Your challenger is picked at random.",
  "battles.picker.fainted": "{name} fainted!",
  "battles.picker.usePill": "Use Pill",
  "battles.picker.yourSquad": "Your Squad",
  "battles.picker.close": "Close",
  "battles.picker.done": "Done",
  "battles.picker.pillTab": "Pill ({left}/{total})",
  "battles.picker.switchTab": "Switch",
  "battles.picker.noSwitch": "No other Suikamon available to switch in",
  "battles.picker.mustSwap": "Choose your next Suikamon — it enters safely after a knockout.",
  "battles.picker.pillHint": "Heals {percent}% of max HP and uses your whole turn.",
  "battles.picker.switchHint": "Switching uses your turn — the enemy may strike the incoming Suikamon!",
  "battles.picker.lastFighter": "No other Suikamon can step in — your last fighter stays on the field.",
  "battles.picker.level": "Lv.{level}",
  "battles.picker.inBattle": "In Battle",
  "battles.picker.faintedBadge": "Fainted",
  "battles.picker.hp": "{hp}/{maxHp} HP",
  "battles.picker.healPreview": "Heal +{hp} HP",
  "battles.picker.fullHp": "Full HP",
  "battles.picker.noReplacement": "No replacement is available.",
  "battles.picker.rosterSize": "{count} Suikamon",
  "battles.picker.pillsLeft": "{left}/{total} pills",
  "battles.campaign.backTo": "Back to {world}",
  "battles.campaign.challenger": "Challenger",
  "battles.campaign.rivalAlt": "{title} {name}",
  "battles.campaign.chooseStarter": "Choose your starter",
  "battles.campaign.matchupAria": "Squad matchup",
  "battles.campaign.yourSquad": "Your Squad",
  "battles.campaign.squadCount": "{picked}/{capacity}",
  "battles.campaign.swap": "Swap",
  "battles.campaign.change": "Change",
  "battles.campaign.slotAria": "Choose a Suikamon for slot {slot}",
  "battles.campaign.tapToPick": "Tap to pick",
  "battles.campaign.pickOne": "Pick one",
  "battles.campaign.tapToSwap": "Tap a Suikamon to swap it",
  "battles.campaign.tapToChange": "Tap a Suikamon to change your squad",
  "battles.campaign.clearAll": "Clear all slots",
  "battles.campaign.rivalSquad": "Rival Squad",
  "battles.campaign.rivalFallback": "Rival",
  "battles.campaign.rulesAria": "Battle rules",
  "battles.campaign.levelCap": "Lv.{level} cap",
  "battles.campaign.matchSize": "{you} v {rival}",
  "battles.campaign.noXp": "No XP",
  "battles.campaign.xp": "+{xp} XP",
  "battles.campaign.rewardDailyRival": "Rival of the Day",
  "battles.campaign.rewardReplay": "replay",
  "battles.campaign.rewardFirstClear": "first clear",
  "battles.campaign.rivalScales": "Rival scales to you",
  "battles.campaign.bringMore": "{count, plural, one {Tap a slot above to bring # more Suikamon — the rival brings all {rival}.} other {Tap a slot above to bring # more Suikamon — the rival brings all {rival}.}}",
  "battles.campaign.preparing": "Preparing…",
  "battles.campaign.fightDailyRival": "Fight Rival of the Day",
  "battles.campaign.fightAgain": "Fight again",
  "battles.campaign.battle": "Battle!",
  "battles.campaign.hatchToFight": "Hatch {name} to fight this battle.",
  "battles.campaign.needsYou": "{name} needs you before this battle.",
  "battles.campaign.hatchName": "Hatch {name}",
  "battles.campaign.goTo": "Go to {name}",
  "battles.campaign.slotLabel": "Slot {slot}",
  "battles.store.title": "Skill Store",
  "battles.store.slot.attack": "Attack skills",
  "battles.store.slot.magic": "Magic skills",
  "battles.store.slot.dodge": "Dodge skills",
  "battles.store.slot.recover": "Recover skills",
  "battles.store.filter.all": "All",
  "battles.store.filter.new": "New",
  "battles.store.filter.upgradeable": "Upgradable",
  "battles.store.openFailed": "Could not open the store",
  "battles.store.buyFailed": "Could not buy that copy",
  "battles.store.fullStack": "{card} is now {tier} — that's a full stack!",
  "battles.store.tierProgress": "{card} → {tier} ({progress})",
  "battles.store.gateTitle": "The store opens with a Suikamon",
  "battles.store.gateText": "Start playing free to hatch one — caring for it earns the Suika this store runs on — or sign in to shop for the Suikamon you already have.",
  "battles.store.opening": "Opening the store…",
  "battles.store.hatchFirst": "Hatch a Suikamon first",
  "battles.store.hatchFirstText": "Skills belong to a Suikamon, and the Suika that buys them comes from looking after one.",
  "battles.store.subtitle": "Collect copies to make a skill stronger",
  "battles.store.equip": "Equip →",
  "battles.store.balances": "Your balances",
  "battles.store.shopFor": "Shop for {petName}",
  "battles.store.filterLabel": "Filter the shelf",
  "battles.store.stocking": "Stocking the shelves…",
  "battles.store.emptyNew": "You have collected every skill in the game. Nothing here is new to you.",
  "battles.store.emptyUpgradeable": "Every skill you own is already at full strength. Nothing left to upgrade.",
  "battles.campaign.pickerAria": "Choose a Suikamon for {slot}",
  "battles.campaign.selectFor": "Select for {slot}",
  "battles.campaign.chooseTitle": "Choose a Suikamon",
  "battles.campaign.closePicker": "Close picker",
  "battles.campaign.inThisSlot": "In this slot",
  "battles.campaign.inSquad": "In squad",
  "battles.campaign.happyTitle": "Happy! +{bonus} Attack & Magic damage",
  "battles.campaign.happyHint": "😊 Happy Suikamons deal <b>+{bonus} damage</b>",
  "battles.campaign.removeFromSlot": "Remove from slot",
  "battles.history.loadFailed": "Failed to load battle history",
  "battles.history.loading": "Loading battle history...",
  "battles.history.empty": "No battles yet. Start battling to build your history!",
  "battles.history.title": "⚔️ BATTLE RECORD",
  "battles.history.colResult": "Result",
  "battles.history.colMatch": "Match",
  "battles.history.colDate": "Date",
  "battles.history.won": "WON",
  "battles.history.lost": "LOST",
  "battles.history.draw": "DRAW",
  "battles.history.asAi": "{petName} (AI)",
  "battles.history.badgeTelegram": "TG",
  "battles.history.badgeTrial": "TRIAL",
  "battles.history.vs": "VS",
  "battles.fighter.levelTag": "LV.{level}",
  "battles.fighter.happyTitle": "Happy! +{bonus} Attack & Magic damage in this battle",
  "battles.fighter.levelChip": "⭐Lv.{level}",
  "battles.fighter.hibernating": "HIBERNATING",
  "battles.fighter.xpTotal": "✨ {xp} XP",
  "battles.fighter.trophies": "Trophies",
  "battles.fighter.wins": "{count}W",
  "battles.fighter.losses": "{count}L",
  "battles.fighter.noBattles": "🎮 No battles yet",
  "battles.fighter.milestones": "Milestones",
  "battles.skills.slotTitle.attack": "Attack skill",
  "battles.skills.slotTitle.magic": "Magic skill",
  "battles.skills.slotTitle.dodge": "Dodge skill",
  "battles.skills.slotTitle.recover": "Recover skill",
  "battles.skills.readArt": "{name} — {tier}, read what it does",
  "battles.skills.max": "· Max",
  "battles.skills.equipped": "Equipped",
  "battles.skills.equipAria": "Equip {name}",
  "battles.skills.equip": "Equip",
  "battles.skills.unlockOnSkills": "Unlock on Skills",
  "battles.skills.unlock": "Unlock",
  "battles.skills.toward": "→ {tier}",
  "battles.skills.unlockAria": "Unlock {name}",
  "battles.skills.upgradeAria": "Upgrade {name} toward {tier}",
  "battles.skills.barAriaUnlock": "{have} of {span} copies toward unlocking",
  "battles.skills.barAria": "{have} of {span} copies toward {tier}",
  "battles.skills.buyAria": "{purpose} for {price} Suika",
  "battles.skills.buyShortAria": "{price} Suika — not enough. Tap to see how to earn more",
  "battles.skillsPage.title": "Skills",
  "battles.skillsPage.loadFailed": "Could not load this Suikamon’s skills",
  "battles.skillsPage.short": "{short} more Suika needed. Win campaign battles and care for your Suikamon to earn it.",
  "battles.skillsPage.upgradeFailed": "Could not upgrade that skill",
  "battles.skillsPage.equipFailed": "Could not equip that skill",
  "battles.skillsPage.gateTitle": "Skills belong to a Suikamon",
  "battles.skillsPage.gateText": "Start playing free to hatch one and pick its four moves — no signup needed — or sign in to open the Suikamon you already have.",
  "battles.skillsPage.loading": "Loading skills…",
  "battles.skillsPage.subtitle": "Tap a skill to change it.",
  "battles.skillsPage.back": "← Back to pet",
  "battles.skillsPage.combo": "Combo",
  "battles.skillsPage.freeCap": "Free play stops at level {level}.",
  "battles.squadGrid.eyebrow": "SELECT YOUR SQUAD",
  "battles.squadGrid.count": "{selected}/{max} SUIKAMONS",
  "battles.squadGrid.slot": "Slot {slot}",
  "battles.squadGrid.happyHint": "😊 Happy Suikamons deal <b>+{bonus} Attack & Magic damage</b>.",
  "battles.squadGrid.yourSquad": "YOUR SQUAD",
  "battles.squadGrid.fighterMeta": "{species} Lv.{level} · Slot {slot}",
  "battles.record.level": "Level",
  "battles.record.xpProgress": "{current} / {needed} XP",
  "battles.record.record": "Record",
  "battles.record.winLoss": "{wins}W {losses}L",
  "battles.record.wonRate": "{rate} won",
  "battles.record.noBattles": "No battles yet",
  "battles.record.trophies": "Trophies",
  "battles.record.next": "Next: {emoji} {elo}",
  "battles.record.allTiers": "Every tier reached",
  "battles.record.tierPays": "Each new tier pays {min}–{max} {currency}",
  "battles.cardFace.ariaRepeat": "{card} — {suit}, another copy",
  "battles.cardFace.ariaEvolutionSet": "{card} — {suit}, {copies, plural, one {# copy} other {# copies}}, evolution set complete — this card is spent on the rung when the hand locks",
  "battles.cardFace.ariaOutranked": "{card} — {suit}, {copies, plural, one {# copy} other {# copies}}, spent with {suit} but scores nothing — a bigger stack carries the suit",
  "battles.cardFace.ariaNoNumber": "{card} — {suit}, {copies, plural, one {# copy} other {# copies}}, no number on it — it adds nothing to the move",
  "battles.cardFace.ariaLands": "{card} — {suit}, {copies, plural, one {# copy} other {# copies}}, lands at {value}",
  "battles.played.theyPlayed": "They played",
  "battles.played.youPlayed": "You played",
  "battles.played.stunnedAria": "stunned — no cards played",
  "battles.played.bare": "no cards — {suit} bare",
  "battles.played.lands": "{card} → {value}",
  "battles.played.nothingScored": "{suit} — nothing scored",
  "battles.played.boostedAria": "boosted this round",
  "battles.gate.signUp": "Sign up to compete",
  "battles.gate.trainNamed": "Train {name} now",
  "battles.gate.train": "Train now",
  "battles.gate.back": "Back to your pet",
  "battles.gate.portal": "Your Suikamon fights in Training battles and the story campaign.",
  "battles.gate.fighterFact": "{name} · Lv.{level}",
  "battles.evoChip.aria": "Evolution {rank}",
  "battles.evoChip.ariaNamed": "{name}: Evolution {rank}",
  "battles.evoChip.ariaMax": "Evolution {rank}, fully evolved",
  "battles.evoChip.ariaMaxNamed": "{name}: Evolution {rank}, fully evolved",
  "battles.evoChip.max": "Max Evo",
  "battles.evoChip.rank": "Evo {rank} of {max}",
  "battles.stack.copies": "{count, plural, one {# copy} other {# copies}}",
  "battles.recoverAim.aria": "Choose who your Recover heals",
  "battles.recoverAim.label": "Heal who?",
  "battles.recoverAim.full": "full HP",
  "battles.recoverAim.hp": "{hp} of {max} HP",
  "battles.recoverAim.healAria": "Heal {name}, {state}",
  "battles.recoverAim.healAriaSelf": "Heal {name}, in battle, {state}",
  "battles.recoverAim.title": "{name} — {state}",
  "battles.recoverAim.cancel": "Cancel Recover",
  "battles.shika.show": "Show Shika's commentary",
  "battles.shika.dismiss": "Dismiss Shika",
  "battles.shika.result": "Turn result",
  "battles.shika.vs": "vs",
  "battles.search.level": "Lv. {level}",
  "battles.search.vs": "VS",
  "battles.search.starting": "Battle starting…",
  "battles.search.tip": "Tip",
  "battles.search.nextTip": "Next tip",
  "battles.ko.double": "DOUBLE K.O.",
  "battles.ko.doubleLine": "Both fighters are down",
  "battles.ko.ko": "K.O.",
  "battles.ko.down": "{name} is down",
  "battles.ko.time": "TIME",
  "battles.ko.timeLine": "The turn limit is up",
  "battles.ko.skip": "Tap to skip",
  "battles.beat.continue": "Tap anywhere to continue",
  "battles.tray.stunned": "Stunned!",
  "battles.recoverAim.fainted": "fainted",
  "battles.comic.begin.opening": "Start Your Journey",
  "battles.comic.begin.intro": "Let's go!",
  "battles.comic.begin.keepGoing": "Keep going!",
  "battles.comic.begin.result": "Onward!",
  "battles.comic.begin.ending": "The end… for now",
  "battles.comic.begin.rewatch": "Back to the map",
  "battles.comic.begin.recap": "Back to the campaign",
  "battles.comic.skip": "Skip ✕",
  "battles.comic.tapToContinue": "Tap to continue ›",
  "battles.comic.fightAgain": "⚔️ Fight again — no XP",
  "battles.comic.aria.opening": "Campaign story — your journey begins",
  "battles.comic.aria.reel": "Story page",
  "battles.comic.aria.page": "Page {page} of {total}",
  "battles.comic.aria.musicOn": "Turn the music on",
  "battles.comic.aria.musicOff": "Turn the music off",
  "battles.comic.aria.skip": "Skip the story",
  "battles.comic.aria.next": "Next",
  "battles.comic.aria.soFar": "{tale} — the story so far",
  "battles.comic.aria.goesOn": "{tale} — the story goes on",
  "battles.comic.aria.twist": "{tale} — a twist",
  "battles.comic.aria.result": "{tale} — what happened",
  "battles.comic.aria.began": "{tale} — how it began",
  "battles.comic.aria.ended": "{tale} — how it ended",
  "battles.comic.aria.ending": "The story of Suikara — the ending",
  "battles.comic.aria.battle": "{rival} — the story",
  "battles.encounter.wildPack": "The wild pack",
  "battles.encounter.wildOne": "Wild Suikamon",
  "battles.encounter.sendsOut": "{rival} sends out",
  "battles.encounter.wildAria": "A wild {species} appeared",
  "battles.encounter.rivalAria": "{name} wants to battle",
  "battles.encounter.wildKicker": "🐾 A wild {species} appeared!",
  "battles.encounter.rivalKicker": "⚔️ {rival} wants to battle!",
  "battles.comic.wonCaption": "You won!"
}
